module.exports = __webpack_public_path__ + "static/video_back-7ae8cffcc438496b5d95d69af1f8040f.mp4";